/**
 * Módulos da barra superior: a unidade dos direitos retirados do administrador
 * restrito (ADR 0027, 11/10/2026). Os valores são os do enum `AccessModule` do
 * backend, que também barra as rotas de API do módulo retirado.
 */
export type AccessModule = "OPERACOES" | "PROCESSOS" | "DP" | "FINANCEIRO" | "ESTOQUE" | "ADMINISTRACAO" | "CAMPANHAS";

/** Na ordem da barra. */
export const ACCESS_MODULES: { key: AccessModule; label: string }[] = [
  { key: "OPERACOES", label: "Operações" },
  { key: "PROCESSOS", label: "Processos Zé" },
  { key: "DP", label: "Departamento Pessoal" },
  { key: "FINANCEIRO", label: "Financeiro" },
  { key: "ESTOQUE", label: "Estoque" },
  { key: "ADMINISTRACAO", label: "Administração" },
  { key: "CAMPANHAS", label: "Campanhas" },
];

export const accessModuleLabel = (key: string) => ACCESS_MODULES.find((m) => m.key === key)?.label ?? key;

/**
 * Início das rotas de cada módulo. Telas operacionais antigas vivem fora de
 * `/operacoes` (herança do app antigo) e entram pela lista. Tela nova de módulo
 * sob um destes prefixos fica coberta sem mexer aqui.
 */
const MODULE_PREFIXES: [string, AccessModule][] = [
  ["/operacoes", "OPERACOES"],
  ["/store", "OPERACOES"],
  ["/agenda", "OPERACOES"],
  ["/freelancer-control", "OPERACOES"],
  ["/slots-manager", "OPERACOES"],
  ["/update-presence", "OPERACOES"],
  ["/update-presence-and-values", "OPERACOES"],
  ["/evalaution-forms-admin-page", "OPERACOES"],
  ["/freelancer-ratings", "OPERACOES"],
  ["/processos-ze", "PROCESSOS"],
  ["/fefo", "PROCESSOS"],
  ["/dp", "DP"],
  ["/financeiro", "FINANCEIRO"],
  ["/estoque", "ESTOQUE"],
  ["/administracao", "ADMINISTRACAO"],
  ["/admin", "ADMINISTRACAO"],
  ["/campanhas", "CAMPANHAS"],
];

/** Módulo dono da rota, por segmento inteiro (`/store` não casa com `/stores`). */
export function moduleForPath(pathname: string): AccessModule | undefined {
  return MODULE_PREFIXES.find(([prefix]) => pathname === prefix || pathname.startsWith(`${prefix}/`))?.[1];
}
